import React, { memo } from 'react';
import { Helmet } from 'react-helmet-async';
import { areEqual } from 'react-window';
import { getImageUrl } from '@/utils/helpers';

import OGImage from './og-image';
import { SEOImageProps } from './SEOImage.interface';

const SEOImage = ({ image = {}, isFallback = true }: SEOImageProps) => {
  const imageUrl = React.useMemo(() => getImageUrl(image), [image]);
  const [hasImage, setHasImage] = React.useState(false);

  const persistImage = React.useCallback(() => {
    OGImage.getInstance().currentImage = imageUrl;
    OGImage.getInstance().currentUrl = window.location.href;
  }, [imageUrl]);

  React.useEffect(() => {
    const hasPreviousImage = window.location.href === OGImage.getInstance().currentUrl;

    const fallbackHasImage = isFallback && !hasPreviousImage && !!imageUrl;
    const seoHasImage = !isFallback && !!imageUrl;
    const isImage = fallbackHasImage || seoHasImage;

    if (!isImage) return;

    persistImage();
    setHasImage(true);
  }, [imageUrl, isFallback, persistImage]);

  if (!hasImage) return null;

  return (
    <Helmet>
      {imageUrl && <meta property="es:image" content={imageUrl} />}
      {imageUrl && <meta name="twitter:image" content={imageUrl} />}
      {imageUrl && <meta property="og:image" content={imageUrl} />}
      {imageUrl && <meta property="og:image:secure_url" content={imageUrl} />}
    </Helmet>
  );
};

export default memo(SEOImage, areEqual);
